import { CSSProperties } from "react";

const ShopifyNativeHelpText = ({ text, style }: { text: string; style?: CSSProperties }) => {
    return (
        <div className={"Polaris-Labelled__HelpText"} id=":r31:HelpText" style={{ marginTop: -10, ...style }}>
            <span className={"Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--break Polaris-Text--subdued"}>
                {text}
            </span>
        </div>
    );
};

export default ShopifyNativeHelpText;
